import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faClock, faEnvelope, faLocationArrow, faStar, faMoneyBillAlt, faQuestionCircle, faWifi } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const Footer = () => {
    return (
        <footer id="contact" style={{ fontFamily: 'D-DIN Exp, sans-serif' }} className="footer my-5 p-3">
            <div className="left-section">
                <div className="footer-logo">
                    <img className='footer-img m-3' src="../images/connekt-logo-1.png" alt="Connekt Logo" />
                    <p>Welcome to the largest broadband and Internet <br />
                        services provider where you can choose the best <br />
                        plan ever. We guarantee customer support <br />
                        service with high-speed connection.</p>
                    <div className='social-media'>
                        <a style={{ textDecoration: "none", color: "gray" }} href="https://x.com/connektonline?s=21&t=EtQi5HRqonedozNOs1mWxg" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon size='2x' icon={faXTwitter} />
                        </a>
                        <a style={{ textDecoration: "none", color: "gray" }} href="https://www.facebook.com/ConnektOnline" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon size='2x' icon={faFacebook} />
                        </a>
                        <a style={{ textDecoration: "none", color: "gray" }} href="https://www.instagram.com/connektonline?igsh=MXNkazhlaDIxb3A3Mg==" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon size='2x' icon={faInstagram} />
                        </a>
                    </div>
                </div>
            </div>

            <div className="middle-section">
                <ul className="footer-list">
                    <li><h4>CONTACT US</h4></li>
                    <li><FontAwesomeIcon icon={faPhone} /> +2349088998930</li>
                    <li><FontAwesomeIcon icon={faEnvelope} /> Info@connekt.me</li>
                    <li><FontAwesomeIcon icon={faClock} /> 09:00 AM - 05:00 PM</li>
                    <li><FontAwesomeIcon icon={faLocationArrow} /> Ikate Elegushi, Lagos,</li>
                    <li>Nigeria</li>
                </ul>
            </div>

            <div className="right-section">
                <ul className="footer-list">
                    <li><h3>LINKS</h3></li>
                    <li><FontAwesomeIcon icon={faStar} /> Features</li>
                    <li><FontAwesomeIcon icon={faMoneyBillAlt} /> Pricing</li>
                    <li><FontAwesomeIcon icon={faQuestionCircle} /> FAQ’s</li>
                    <li><FontAwesomeIcon icon={faWifi} /> Connekt Now</li>
                </ul>
            </div>
        </footer>
    );
};

export default Footer;
